import { useGetSearchParams } from '@/hooks/useGetSearchParams';
import { useReplaceSearchParams } from '@/hooks/useReplaceSearchParams';

export const useTableSorting = (columnName: string, hasSort: boolean) => {
  const { replaceSearchParams } = useReplaceSearchParams();
  const { ordering } = useGetSearchParams();

  const isAscendingSorting = hasSort && ordering === columnName;
  const isDescendingSorting = hasSort && ordering === `-${columnName}`;
  const isUnsorted = hasSort && !isAscendingSorting && !isDescendingSorting;

  const getNextSortingField = () => {
    /* Next sorting field logic:
      Unsorted >> Ascending
      Ascending >> Descending
      Descending >> Unsorted
    */
    if (isUnsorted) return columnName;
    if (isAscendingSorting) return `-${columnName}`;
    if (isDescendingSorting) return null;

    return null;
  };

  const changeSorting = () => {
    if (!hasSort) return;

    const sortingOrder = getNextSortingField();

    replaceSearchParams({ ordering: sortingOrder });
  };

  return {
    changeSorting,
    isAscendingSorting,
    isDescendingSorting,
    isUnsorted,
  };
};
